import { Volume2, VolumeX } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SoundControlProps {
  isMuted: boolean;
  onToggle: () => void;
}

export const SoundControl = ({ isMuted, onToggle }: SoundControlProps) => {
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onToggle}
      className="fixed top-4 right-4 z-50 bg-background/50 backdrop-blur-sm hover:bg-background/80"
      aria-label={isMuted ? "Activer le son" : "Couper le son"}
    >
      {isMuted ? (
        <VolumeX className="w-5 h-5 text-muted-foreground" />
      ) : (
        <Volume2 className="w-5 h-5 text-foreground" />
      )}
    </Button>
  );
};
